import lodash from 'lodash';
import { useContext } from 'react';

import { EditorContext, ToolbarContext } from './../../ricos-context';

import { DEFAULT_LINE_SPACING } from '../defaults';
import type { LineSpacings } from '../types';

export const useCurrentSpacing = (): LineSpacings => {
  /* defaultSpacing is set on consumer side through plugin-line-spacing config */
  const { defaultLineSpacing: defaultSpacing } = useContext(ToolbarContext);
  const { getPublicCommands } = useContext(EditorContext);
  const publicCommands = getPublicCommands();
  const currentSpacing = publicCommands.getBlockSpacing();

  return {
    ...DEFAULT_LINE_SPACING,
    ...lodash.omitBy(defaultSpacing, lodash.isNil),
    ...lodash.omitBy(currentSpacing, lodash.isNil),
  };
};
